import React from 'react';

import { Content } from 'LegacySBCRA/Content/Content';
import { HeadlineStats } from 'Storybook/components/local/HeadlineStats';

import { usePageRefEvents } from '../../../common/Hooks/usePageRefEvents';
import { type RoundedSectionType, RoundedSection } from '../../../common/RoundedSection/RoundedSection';
import type { StatItemBlock } from '../../@types/landingPages';
import { landingPageSectionLoadEvent, PAGE_SECTIONS } from '../../Pages/LandingPage.helpers';

import styles from './Statistics.scss';

type StatisticsProps = {
  stats: StatItemBlock[];
  theme?: RoundedSectionType;
  title?: string;
};

export const Statistics = ({ stats = [], theme = 'primary-yellow', title }: StatisticsProps) => {
  const { setRef } = usePageRefEvents({
    onRefTrigger: () => landingPageSectionLoadEvent(PAGE_SECTIONS.STATISTICS),
  });

  const validStats = stats.filter((item) => item?.stat && item?.subtitle);

  if (!validStats.length) {
    return null;
  }

  return (
    <RoundedSection withBottomLedge withTopLedge className={styles.wrapper} theme={theme}>
      <Content center className={styles.content}>
        <div ref={(ref) => setRef(ref)}>
          {title ? <h2>{title}</h2> : null}
          <HeadlineStats stats={validStats} />
        </div>
      </Content>
    </RoundedSection>
  );
};
